import 'slick-carousel'
import 'jquery'
import { EventEmitter } from 'eventemitter3'
import Timer from '@/core/util/Timer'

class MainCarouselController extends EventEmitter {
  // DOM
  private carouselDom: Element

  // 現在表示中のパネル番号
  private currentIndex = 0

  //
  private carouselItem: Array<HTMLElement>

  //
  private dots: Array<HTMLElement>

  /**
   * コンストラクタ
   *
   */
  constructor(carouselDom: Element) {
    super()
    this.carouselDom = carouselDom

    const _carouselItem = this.carouselDom.getElementsByClassName(
      'main-carousel-item',
    )
    this.carouselItem = Array.from(_carouselItem) as Array<HTMLElement>

    const _dots = this.carouselDom.getElementsByClassName(
      'main-carousel--dot__dot',
    )
    this.dots = Array.from(_dots) as Array<HTMLElement>

    // 表示
    this.show(0)

    this.loop()
  }

  private async loop(): Promise<void> {
    await Timer.wait(6000)
    this.next()
    this.loop()
  }

  /**
   * 次へ
   */
  private next() {
    let nextIndex = this.currentIndex + 1
    if (nextIndex >= this.carouselItem.length) nextIndex = 0
    this.show(nextIndex)
  }

  /**
   * 表示
   */
  private show(index: number) {
    if (
      this.carouselItem[this.currentIndex].classList.contains('is-selected')
    ) {
      this.carouselItem[this.currentIndex].classList.remove('is-selected')
    }

    if (this.dots[this.currentIndex].classList.contains('is-selected')) {
      this.dots[this.currentIndex].classList.remove('is-selected')
    }

    this.currentIndex = index
    this.carouselItem[index].classList.add('is-selected')
    this.dots[index].classList.add('is-selected')
  }

  /**
   *
   */
  public init(): void {
    // currentIndex
  }
}

export default MainCarouselController
